export type UserAgentData = {
  deviceType: string;
  browserName?: string;
  browserVersion?: string;
  osName?: string;
};

export const getFallbackDeviceType = () => {
  const {innerWidth} = window;
  return innerWidth < 720 ? 'mobile' : innerWidth < 1024 ? 'tablet' : 'desktop';
};

export const parseUserAgent = async (): Promise<UserAgentData> =>
  import('ua-parser-js')
    .then(({UAParser}) => {
      const parser = new UAParser(navigator.userAgent);
      return {
        deviceType: parser.getDevice()
          ? parser.getDevice().type || 'desktop'
          : getFallbackDeviceType(),
        browserName: parser.getBrowser()?.name,
        browserVersion: parser.getBrowser()?.version,
        osName: parser.getOS()?.name,
      };
    })
    .catch((e) => {
      console.error(e);
      return {
        deviceType: getFallbackDeviceType(),
      };
    });

export const isAppleDevice = () =>
  /iPhone|iPad|iPod/i.test(navigator.userAgent);
